exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".privacy{padding:20px}.privacy a{color:#fff;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/components/Privacy/privacy.scss
// module id = 163
// module chunks = 0